const { smoothScroll } = require('./common/smoothScroll');
const { getRandomIntInclusive } = require('./helpers');
const { clearUrlFromStorage } = require('./keto-v3/url-storage-operations');
const { GlobalModal } = require('./scripts/global/modal');
const { fetcher } = require('./fetcher');
const { buildEvent: buildPageViewEvent } = require('./tracking/events/PageView');

const plan = {
  dom: null,
  selectedActiveClassList: [
    'active',
    'text-transparent',
    'bg-clip-text',
    'bg-theta-gradient-2',
    'after:bg-theta-gradient-2',
  ],
  init() {
    this.dom = {
      weekSelectItems: document.querySelectorAll('.js-select-item'),
      daysButtons: document.querySelectorAll('.js-day'),
      dayWords: document.querySelectorAll('.js-day-word'),
      weekToggleButton: document.querySelector('.js-week-select-button'),
      closeMenuButton: document.querySelector('.js-close-menu'),
      weekDisplayTab: document.querySelector('.js-week-text'),
      dayDisplayTab: document.querySelector('.js-day-text'),
      weekMenu: document.querySelector('.js-week-menu'),
      weekView: document.querySelector('.js-product-body'),
      loader: document.querySelector('.js-loader'),
      popups: document.querySelectorAll('.js-upsale-popup'),
      popupsClose: document.querySelectorAll('.js-close'),
      dietRefresh: document.querySelector('.diet-refresh'),
      toggleEvent: new Event('toggleScroll'),
      downloadPdfButton: document.querySelector('.download-plan-button'),
      isMobile: isAndroidMobile || isIOSMobile,
      get toObserve() {
        return [this.weekMenu, ...this.popups];
      },
    };

    if (location.pathname.replace(/^.+\/week\//, '') > this.dom.weekSelectItems.length) {
      window.history.pushState(null, '', this.getDietUrl() + 'week/1' + window.location.search);
    }

    const likedRecipes = store.get('likedRecipes');
    const bearerToken = document.querySelector('#bearer_token').textContent;
    const dailyRecipesUrl = document.querySelector('.js-burger-menu-change-daily-recipes');
    dailyRecipesUrl?.addEventListener('click', clearUrlFromStorage());

    !likedRecipes && this.saveRecipesInStorage(bearerToken);

    likedRecipes && this.setLikedRecipesState(likedRecipes || []);

    this.dom.weekToggleButton.addEventListener('click', this.handleWeekButtonClick.bind(this));
    this.dom.closeMenuButton.addEventListener('click', this.handleWeekButtonClick.bind(this));

    [...this.dom.popupsClose].forEach(closeBtn =>
      closeBtn.addEventListener('click', e => {
        this.toggleClass(e.currentTarget.parentElement.parentElement, 'hidden');
        e.currentTarget.parentElement.parentElement.dispatchEvent(this.dom.toggleEvent);
      }),
    );

    [...this.dom.daysButtons].forEach(daySelect =>
      daySelect.addEventListener('click', e => this.changeDay(e.currentTarget, true)),
    );

    [...this.dom.popups].forEach(popup => {
      popup.addEventListener('click', e => {
        if (e.target.classList.contains('js-upsale-popup')) {
          [...this.dom.popups].forEach(e => {
            if (!e.classList.contains('hidden')) {
              e.classList.add('hidden');
              e.dispatchEvent(this.dom.toggleEvent);
            }
          });
        }
      });
    });

    [...this.dom.weekSelectItems].forEach(weekSelect => {
      weekSelect.addEventListener('click', e => this.changeWeek(e));
      weekSelect.addEventListener('back-forward-click', e => this.changeWeek(e));
    });
    this.changeImgPathAccordingToResolution(document.querySelectorAll('.js-mobile-image'));

    document.querySelector('.meal-plan').addEventListener('click', e => {
      if (
        e.target !== this.dom.weekMenu &&
        e.target !== this.dom.weekToggleButton &&
        this.dom.weekMenu.classList.contains('week-menu--active')
      ) {
        this.removeActiveState([this.dom.weekMenu], ['week-menu--active']);
        this.dom.weekMenu.dispatchEvent(this.dom.toggleEvent);
      }
    });

    if (this.dom.weekView.children.length === 0) {
      this.dom.loader.classList.remove('hidden');
      this.setWeekView();
      return;
    }

    if (this.dom.dietRefresh) {
      setTimeout(() => {
        window.location.reload(true);
      }, 3000);
    }

    this.dom.toObserve.forEach(observable => observable.addEventListener('toggleScroll', e => this.toggleNoScroll(e)));
    this.setVisualState();
  },
  toggleNoScroll(mutation) {
    const docBody = document.querySelector('body');
    const classes = ['noscroll', 'overflow-hidden', 'fixed-content'];
    mutation.target.classList.contains('js-upsale-popup') &&
      !mutation.target.classList.contains('hidden') &&
      docBody.classList.add(...classes);
    mutation.target.classList.contains('js-upsale-popup') &&
      mutation.target.classList.contains('hidden') &&
      docBody.classList.remove(...classes);
    mutation.target.classList.contains('js-week-menu') &&
      mutation.target.classList.contains('week-menu--active') &&
      window.innerWidth < 768 &&
      docBody.classList.add(...classes);
    mutation.target.classList.contains('js-week-menu') &&
      !mutation.target.classList.contains('week-menu--active') &&
      docBody.classList.remove(...classes);
  },
  changeImgPathAccordingToResolution(images) {
    [...images].forEach(element => {
      element.style.backgroundImage = `url(${this.dom.isMobile ? element.dataset.mobile : element.dataset.desktop})`;
    });
  },
  getOffset(el) {
    const rect = el.getBoundingClientRect();
    return {
      left: rect.left + window.scrollX,
      top: rect.top + window.scrollY,
    };
  },
  changeDay(element, isClicked) {
    const weekNum = this.getWeekFromUrl();
    const currentDay = +element.dataset.day;
    this.removeActiveState(this.dom.daysButtons, ['product__days_day--active', 'bg-theta-gradient-2', 'text-white']);
    this.removeDayWords(this.dom.dayWords);
    element.classList.add('product__days_day--active', 'bg-theta-gradient-2', 'text-white');
    element.querySelector('.js-day-word').classList.remove('hidden');
    this.dom.dayDisplayTab.textContent = currentDay + 1;

    const dailyChoiceViews = document.querySelectorAll('.js-daily-choice');
    this.setChosenDay(dailyChoiceViews, currentDay);
    isClicked && smoothScroll(this.getOffset(document.querySelector('.main-view')).top, 1000);
    localStorage.setItem('currentDayIndex', currentDay);
    localStorage.setItem('currentDay', currentDay + 1);
    this.setDailyRecipesUrl(weekNum);
  },
  changeWeek(e) {
    const isRegularClickEvent = e.type === 'click';
    const currentSelected = this.getWeekFromUrl();
    const weekSelected = e.currentTarget.dataset.value;
    if (currentSelected == weekSelected && isRegularClickEvent) {
      return;
    }
    this.dom.loader.classList.remove('hidden');
    this.dom.weekView.classList.add('hidden');
    this.removeActiveState(this.dom.weekSelectItems, this.selectedActiveClassList);
    this.removeActiveState([this.dom.weekMenu], ['week-menu--active']);
    this.dom.weekMenu.dispatchEvent(this.dom.toggleEvent);
    e.currentTarget.classList.add(...this.selectedActiveClassList);
    isRegularClickEvent &&
      window.history.pushState(null, '', this.getDietUrl() + 'week/' + weekSelected + window.location.search);
    this.setDailyRecipesUrl(weekSelected);
    this.setWeekView(true, isRegularClickEvent);
  },
  handleWeekButtonClick() {
    this.toggleClass(this.dom.weekMenu, 'week-menu--active');
    this.dom.weekMenu.dispatchEvent(this.dom.toggleEvent);
  },
  setVisualState() {
    const weekNum = this.getWeekFromUrl();
    const ulWeekSelected = document.querySelector('li[data-value="' + weekNum + '"]');
    ulWeekSelected.classList.add(...this.selectedActiveClassList);
    this.dom.weekToggleButton.querySelector('span').textContent =
      this.dom.weekToggleButton.dataset.text + ' ' + weekNum;
    this.dom.weekDisplayTab.textContent = weekNum;

    backEndVars.buttonText.length >= 15 ? this.dom.weekToggleButton.classList.add('!flex-1', 'mb-5', 'md:mb-0') : '';

    this.changeDay(this.dom.daysButtons[localStorage.getItem('currentDayIndex') || 0], false);
    this.setDownloadButton();
  },
  removeActiveState(elements = [], state = []) {
    [...elements].forEach(e => e.classList.remove(...state));
  },
  removeDayWords(elements = []) {
    [...elements].forEach(e => e.classList.add('hidden'));
  },
  setChosenDay(elements, currentDayIndex = 0, state = 'hidden') {
    [...elements].forEach((day, index) => {
      if (index === currentDayIndex) {
        day.classList.remove(state);
      } else {
        !day.classList.contains(state) && day.classList.add(state);
      }
    });
  },
  toggleClass(el, state) {
    el.classList.toggle(state);
  },
  getWeekFromUrl() {
    if (location.pathname.replace(/^.+\/week\//, '') > this.dom.weekSelectItems.length) {
      return '1';
    }
    return location.pathname.replace(/^.+\/week\//, '');
  },
  getDietUrl() {
    return location.href.replace(/week\/.+$/, '');
  },
  getWeekViewUrl() {
    const weekSelected = this.getWeekFromUrl();
    return this.getDietUrl() + 'week-view/' + weekSelected;
  },
  setDataLayer(params = {}) {
    window.dataLayer = window.dataLayer || [];
    dataLayer.push(params);
  },
  setDownloadButton() {
    const productButton = document.querySelector('.js-product-buttons');
    const alertDanger = this.dom.weekView.querySelector('.alert-danger ');
    const downloadForm = this.dom.weekView.querySelector('#download-meal-plan');
    const downloadPdfBtn = this.dom.weekView.querySelector('.download-plan-button');

    if (backEndVars.buttonText.length >= 15) {
      downloadForm?.classList.add('w-full');
      downloadPdfBtn?.classList.replace('w-fit', 'w-full');
    }

    // DEV NOTE these selectors shall be left like so otherwise those elements
    // will have duplicates client-side
    productButton.querySelector('.alert-danger')?.remove();
    productButton.querySelector('#download-meal-plan')?.remove();
    downloadForm && productButton.appendChild(downloadForm);
    downloadForm?.appendChild(alertDanger);
  },
  showRandomPopup() {
    const randomPopupIndex = getRandomIntInclusive(0, this.dom.popups.length - 1);
    const currentPopup = this.dom.popups[randomPopupIndex];
    currentPopup.classList.remove('hidden');
    currentPopup.dispatchEvent(this.dom.toggleEvent);
  },
  setDailyRecipesUrl(weekNum) {
    const dailyRecipesUrl = document.querySelector('.js-burger-menu-change-daily-recipes');

    if (dailyRecipesUrl) {
      dailyRecipesUrl.href = dailyRecipesUrl.href.replace(
        new RegExp('\\/week.*$'),
        '/week/' + weekNum + '/day/' + localStorage.getItem('currentDay'),
      );
    }
  },
  setWeekView(isPopupShown = false, isRegularClickEvent = true) {
    const url = this.getWeekViewUrl();
    this.setDataLayer({
      vpv: 'spaPageview',
      uuid: document.querySelector('#uuid').textContent,
      weekNumber: location.pathname.replace(/^.+\/week\//, ''),
    });
    fetcher
      .get(url, {
        'X-CSRF-TOKEN': document.getElementsByName('csrf-token')[0].content,
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      })
      .then(data => this.loadView(data, isPopupShown, isRegularClickEvent))
      .catch(err => this.handleWeekViewError(err));
  },
  handleWeekViewError(err) {
    if (err.status === 422) {
      let text = err.error.message;

      let continueLabel = backEndVars.translations.tm1020;

      const modal = new GlobalModal();
      modal.setConfig({
        buttons: [
          {
            text: continueLabel,
            e2e: 'continue',
            callback: () => this.redirectToCompleteDiet(err.error.redirect),
          },
        ],
        content: {
          text: text,
        },
        classes: {
          body: 'noscroll-desktop',
        },
        removeElements: ['closeBtn'],
      });
      modal.init();
    }
    if (err.responseJSON && err.responseJSON.missing === true) {
      location.reload();
    }
  },
  redirectToCompleteDiet(redirect) {
    let redirectURL = redirect + '?modalRedirect=422';
    window.location.href = redirectURL;
  },
  loadView(data, isPopupShown, isRegularClickEvent) {
    this.dom.loader.classList.add('hidden');
    this.dom.weekView.innerHTML = data.view;
    this.dom.weekView.classList.remove('hidden');
    if (!localStorage.getItem('currentDayIndex')) {
      localStorage.setItem('currentDayIndex', 0);
    }
    this.setVisualState();
    this.setLikedRecipesState(store.get('likedRecipes'));
    isPopupShown && isRegularClickEvent && this.showRandomPopup();

    tracking.trackClient(buildPageViewEvent());
  },
  saveRecipesInStorage(bearerToken) {
    const url = `${window.getHost()}/api/recipes/favorite`;

    fetcher
      .get(url, {
        Accept: 'application/json',
        Authorization: 'Bearer ' + bearerToken,
      })
      .then(({ data }) => {
        const currentData = data || [];
        store.set('likedRecipes', currentData);
        this.setLikedRecipesState(currentData);
      });
  },
  setLikedRecipesState(recipeIds) {
    recipeIds.forEach(id => {
      const iconsWithState = document.querySelectorAll(`[data-recipe-id="${id}"]`) || [];
      iconsWithState.forEach(icon => {
        const likedSvg = icon.querySelector('.js-liked-svg');
        likedSvg.classList.remove('hidden');
        const likedText = icon.querySelector('.js-liked-text');
        likedText?.classList.remove('hidden');
        const dislikedSvg = icon.querySelector('.js-disliked-svg');
        dislikedSvg.classList.add('hidden');
      });
    });
  },
};

module.exports = plan;

document.addEventListener('DOMContentLoaded', () => {
  plan.init();
  window.addEventListener('popstate', function (event) {
    const weekSelected = plan.getWeekFromUrl();
    const weekSelectedButton = document.querySelector(`[data-value="${weekSelected}"]`);
    weekSelectedButton.dispatchEvent(new Event('back-forward-click'));
  });
});
